'use strict';

import { getUrlParam } from '../../functions';
import {isDesktop, isMobile} from '../../settings';
import { sendUserID } from '../crm/crm-requests';
import { Cookie } from '../Cookie/Cookie';

export class UserAPI {
    constructor () {
        this.id = Cookie.getCookie('userId');
        if (!this.id) {
            this.id = this.uniqueID;
            Cookie.setCookie('userId',this.id);
        }

        this.clientId = getUrlParam('clientId');
        this.deviceType = isDesktop ? 'desktop' : isMobile ? 'mobile' : 'web';
    }

    send() {
        const sendData = {
            uniqueId: this.id,
            deviceType: this.deviceType
        };

        if (this.clientId) {
            sendData.clientId = this.clientId;
        }

        sendUserID(sendData);
    }

    get uniqueID() {
        const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        const uuid = `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4() + s4() + s4()}`;
        return uuid.toUpperCase();
    }

}
